var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.exists === false)?_c('v-not-found'):_c('v-ext-module',{attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }